import * as actionTypes from "../actions/actionTypes";
import {
  CHANGE_THEME_CONFIGURATION_SUCCESS,
  CACHE_MENU_FILTER_CHECKED_VALUES,
  SET_USER_SELECTED_THEME_NAME,
} from "../actions/actionTypes";
import { doMerge } from "../../utils/dataOptionsValues";
import { produce } from "immer";
import { findMaxIndex } from "../../utils/termConfig";
import {
  buildFilters,
  fromToDateFormatter,
  setDateFilters,
} from "../../utils/formatters/dateFormatter";
import {
  customFilterOptions,
  DATE_FILTER_MODE_CUSTOM,
  DATE_FILTER_MODE_NONE,
  filterTypes,
  FILTER_TYPE_DATE_RANGE,
  hardCodedFilterLabels,
  FILTER_TYPE_SINGLE_DATE,
  FILTER_TYPE_DATE_PRESETS,
  DATE_TERM_MONTH_TO_MONTH,
  likeOperator,
} from "../../utils/constants/constants";
import { migrateDateFilters } from "../../utils/siteConfiguration/dateFilters";
import { castToNumber, isMultiRangeFilterType } from "../../utils/func";
import { endOfYesterday, format, startOfMonth } from "date-fns";
import menuFilterSettingsFormatConverter from "../../utils/formatConverters/menuFilterSettingsFormatConverter";
import { getFiltersFromLocalStorage } from "../../utils/browser";
import { isEqual, orderBy, pull } from "lodash-es";
import { getComparisonModeItem } from "../../Layout/Block/interruptDashboard";
import { v4 as uuid } from "uuid";
import formatter from "../../utils/formatters/formatter";
import { applyComparisonSettingsToDraft } from "./layoutReducerComparisonMode";
import { convertCustomDefaultValue } from "../../Pages/SiteConfiguration/Components/AdminMenuFilters/helper";
import { getUserSelectedDateOption } from "../../Layout/LeftMenu/ToDateFilters/customDateUtils";
import { customFilterTypes } from "../../utils/constants/filterConstants";
import { formatISODate } from "../../utils/dates/dateFunc";
import { isRunningInTest } from "../../utils/env";
import { mergeMenuFilters } from "../../utils/menuFilters";

export function setDataUniqueRowUuid(data) {
  return (data ?? []).map((item) => ({ ...item, uniqueRowUuid: uuid() }));
}

const initialState = {
  domain: "",
  siteName: "",
  logo: null,
  favicon: null,
  loginBackground: null,
  tabs: [],
  tabsError: null,
  dateFilters: {},
  menuFilters: [],
  singleQueryFiltersByQueryUuid: {},
  menuFiltersSelectedValuesByMenuFilterUuid: {},
  multiRangeFilters: null,
  menuFilterValueShortlists: {},
  booleanFilters: [],
  dateFiltersConfig: null,
  tenantId: null,
  headerVis: false,
  filtersUpdateHeaderKPIs: false,
  links: [],
  theme: {},
  userSelectedThemeName:
    typeof window !== "undefined"
      ? window.localStorage.getItem("userSelectedThemeName")
      : null,
  loading: true,
  header: null,
  landing: false,
  invalidDomain: null,
  additionalTheme: {},
  term: null,
  activeTab: {},
  dataSourceAccessConfig: convertDataSourcesAccess([]),
  importantNotifications: [],
  importantNotificationsLoading: false,
  currentDateTerm: isRunningInTest ? "[Month-To-Date]" : null,
  markerIODestination: "",
  comparisonMode: null,
  comparisonModeFilterName: null,
  dateFilterType: null,
  userSettings: null,
  isGlobalSticky: false,
  customDatesFilterTypeMap: {},
  searchFilterLoading: false,
  savedMenuFilterGroups: null,
  menuFilterGroupUuid: null,
  menuFilterGroupsLoading: false,
  menuFilterGroupOverride: false,
  currentDateString: formatISODate(new Date()),
};

// TODO: replace it with real options from site config
const comparisonOptions = [
  {
    options: ["GeneralManager", "RegionalSalesDirector", "Store", "FitterName"],
    count: 2,
    pages: ["44EE9635-7A4B-4C85-BAAA-8A156C33E819"],
    checked: 0,
  },
  {
    options: [
      "GeneralManager",
      "RegionalSalesDirector",
      "FitterName",
      "Store",
      "State",
      "Vintage",
      "FitterTenure",
    ],
    count: Infinity, // dynamic
    pages: ["A837BBA3-5613-4BD4-B107-0C60146DE099"],
    checked: 0,
    useFilterUnselect: true,
  },
  {
    options: ["GeneralManager", "RegionalSalesDirector", "FitterName"],
    count: Infinity, // dynamic
    pages: ["656E160D-0886-498D-B01B-A245B3B280A9"],
    checked: 0,
    useFilterUnselect: true,
  },
  {
    options: ["internationalFitter"],
    count: Infinity, // dynamic
    pages: ["9F945F2A-EB8C-4E29-9F0B-440704C5AC21"],
    checked: 0,
    useFilterUnselect: true,
  },
  {
    options: [
      "GeneralManager",
      "RegionalSalesDirector",
      "FitterName",
      "Store",
      "State",
      "Vintage",
      "FitterTenure",
    ],
    count: Infinity, // dynamic
    pages: ["B3D54994-0C53-4372-BE75-3AD0A36A939F"],
    checked: 0,
    useFilterUnselect: true,
  },
];

const comparisonOptionsDemo = [
  {
    options: ["State", "FarmType"],
    count: 2,
    pages: ["661CCF03-5D34-416A-BA34-CAF31811B37D"],
    checked: 0,
  },
];

const comparisonOptionsSpringDemo = [
  {
    options: ["Market", "PortCo"],
    count: 2,
    pages: ["85B3700F-332F-47B0-9AC8-8C3E5CB886F9"],
    checked: 0,
  },
];

const comparisonOptionsProSports = [
  {
    options: ["GeneralManager", "RegionalSalesDirector", "Store", "FitterName"],
    count: 2,
    pages: ["94CCDBE3-1F6F-464C-9760-97F936E4AF98"],
    checked: 0,
  },
  {
    options: [
      "GeneralManager",
      "RegionalSalesDirector",
      "FitterName",
      "Store",
      "State",
      "Vintage",
    ],
    count: Infinity, // dynamic
    pages: ["0FB5D0D2-7926-4BC5-A697-CBBAC19EE72A"],
    checked: 0,
    useFilterUnselect: true,
  },
  {
    options: ["GeneralManager", "RegionalSalesDirector", "FitterName"],
    count: Infinity, // dynamic
    pages: ["656E160D-0886-498D-B01B-A245B3B280A9"],
    checked: 0,
    useFilterUnselect: true,
  },
  {
    options: ["GeneralManager", "RegionalSalesDirector", "FitterName"],
    count: Infinity, // dynamic
    pages: ["C27D7F8F-90BD-4B70-9307-62166796C552"],
    checked: 0,
    useFilterUnselect: true,
  },
];

export { initialState as layoutInitialState };

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CHECK_AUTH_START:
      return { ...state, landing: false, loading: true };

    case actionTypes.CHECK_AUTH_FAIL:
      return { ...state, loading: false };

    case actionTypes.SET_ACTIVE_TAB: {
      const activeTabUuid = action.data?.uuid;
      // Adjust dates according to the user's selection when switching tabs.
      const dates = getUserSelectedDateOption(
        state.dateFiltersConfig,
        activeTabUuid
      );

      const comparisonModeItem =
        getComparisonModeItem(state.comparisonMode, activeTabUuid) ?? {};

      const inComparisonMode =
        comparisonModeItem.pages?.includes(activeTabUuid);

      return {
        ...state,
        isGlobalSticky: false,
        activeTab: action.data,
        ...(inComparisonMode && {
          menuFilters: state.menuFilters.map((filter) => ({
            ...filter,
            values: comparisonModeItem.options?.includes(filter.name)
              ? filter.values.map((value) => ({
                  ...value,
                  checked: false,
                }))
              : filter.values,
          })),
          comparisonMode: state.comparisonMode.map((item) => ({
            ...item,
            checked: 0,
          })),
        }),
        // Adjust dates according to the user's selection when switching tabs.
        ...(dates && {
          dateFilters: {
            start: { ...state.dateFilters.start, value: dates.from },
            end: { ...state.dateFilters.end, value: dates.to },
          },
        }),
      };
    }

    case actionTypes.GET_PUBLIC_CONFIG_SUCCESS: {
      const {
        background,
        customPrimaryColor,
        darkThemeEnabled,
        favicon,
        logo,
        siteName,
        tenant,
        additionalTheme,
        markerIODestination,
      } = action.results.data;
      return {
        ...state,
        landing: false,
        loading: false,
        invalidDomain: null,
        siteName,
        logo,
        loginBackground: background,
        favicon,
        tenantId: tenant.uuid,
        theme: {
          name: darkThemeEnabled ? "dark" : "light",
          primary: customPrimaryColor,
          menuPrimary:
            additionalTheme && JSON.parse(additionalTheme).menuPrimary,
        },
        markerIODestination: markerIODestination || "",
      };
    }

    case actionTypes.GET_PUBLIC_CONFIG_FAIL: {
      return {
        ...state,
        loading: false,
        invalidDomain: action.error,
      };
    }

    case actionTypes.LOGIN_SUCCESS:
    case actionTypes.CHECK_AUTH_SUCCESS:
    case actionTypes.UPDATE_TENANT_CONFIG: {
      const {
        tenantConfig,
        dataSourcesAccess = [],
        importantNotifications,
        menuFilterSettings,
        userSettings,
      } = action.results;

      const dates = migrateDateFilters(
        tenantConfig.dateFilters && JSON.parse(tenantConfig.dateFilters)
      );

      // if user select date term and clicked save settings
      // set selected as default
      if (userSettings?.dateFilterSettings) {
        dates.filterCustomTerm = userSettings.dateFilterSettings.term;
      }

      const additionalTheme = tenantConfig.additionalTheme
        ? JSON.parse(tenantConfig.additionalTheme)
        : {};
      const settings = JSON.parse(tenantConfig.settings);
      const dateFilterMode = dates?.filterMode ?? DATE_FILTER_MODE_NONE;
      const localMenuFilterSettings =
        menuFilterSettingsFormatConverter.response.toLocal(menuFilterSettings);

      const filters = filterMapMenuFilters(
        tenantConfig,
        additionalTheme,
        localMenuFilterSettings
      );

      const startValue = configureStartDate(
        tenantConfig.domain,
        dates,
        dateFilterMode,
        userSettings?.dateFilterSettings
      );

      const endValue = configureEndDate(
        dates,
        dateFilterMode,
        tenantConfig.domain,
        userSettings?.dateFilterSettings
      );

      const { dynamicAggregationDefault, dynamicAggregationValues } =
        dates || {};

      function getMaxAggregation() {
        if (dynamicAggregationDefault) {
          return dynamicAggregationDefault;
        }
        return findMaxIndex(dynamicAggregationValues) || null;
      }

      return {
        ...state,
        siteName: tenantConfig.siteName,
        logo: tenantConfig.logo,
        loginBackground: tenantConfig.background,
        favicon: tenantConfig.favicon,
        tenantId: tenantConfig.tenant.uuid,
        tabs: tenantConfig.pages,
        theme: {
          name: tenantConfig.darkThemeEnabled ? "dark" : "light",
          primary: tenantConfig.customPrimaryColor,
          menuPrimary: additionalTheme.menuPrimary,
        },
        additionalTheme,
        dateFiltersConfig: dates || null,
        ...(dateFilterMode !== DATE_FILTER_MODE_NONE && {
          dateFilters: {
            start: {
              type: dates.fieldName,
              value: startValue,
            },
            end: {
              type: dates.fieldName,
              value: endValue,
            },
          },
        }),
        menuFilters: filters,
        menuFiltersSelectedValuesByMenuFilterUuid: {},
        booleanFilters: setNewBooleans(additionalTheme),
        ...(!state.header && {
          header: tenantConfig.showHeaderKPI ? { blocks: [] } : false,
        }),
        // @todo save as setting on site config
        comparisonMode: getComparisonModeOptionsByDomain(
          tenantConfig.domain,
          tenantConfig.comparisonMode
        ),
        loading: false,
        invalidDomain: null,
        headerVis: tenantConfig.showHeaderKPI,
        domain: tenantConfig.domain,
        filtersUpdateHeaderKPIs: !!settings?.filtersUpdateHeaderKPIs,
        term: getMaxAggregation(),
        twoFactorAuthRequired: tenantConfig.twoFactorAuthRequired,
        dataSourceAccessConfig: convertDataSourcesAccess(dataSourcesAccess),
        importantNotifications,
        markerIODestination: tenantConfig.markerIODestination || "",
        hasDataDictionary: tenantConfig.hasDataDictionary,
        userSettings,
      };
    }

    case actionTypes.RECHECK_AUTH_SUCCESS: {
      const { tenantConfig, menuFilterSettings } = action.results.data;

      const additionalTheme = tenantConfig.additionalTheme
        ? JSON.parse(tenantConfig.additionalTheme)
        : {};

      const localMenuFilterSettings =
        menuFilterSettingsFormatConverter.response.toLocal(menuFilterSettings);

      const newFilters = filterMapMenuFilters(
        tenantConfig,
        additionalTheme,
        localMenuFilterSettings
      );

      return produce(state, (draft) => {
        draft.menuFilters = mergeMenuFilters(state.menuFilters, newFilters);
      });
    }

    case actionTypes.UPDATE_TWO_FACTOR_AUTHENTICATION_REQUIRED: {
      return {
        ...state,
        twoFactorAuthRequired: action.payload,
      };
    }

    case actionTypes.LOAD_LANDING_SITE:
      return {
        ...state,
        landing: true,
      };

    case actionTypes.LOAD_HEADER_CONFIG_SUCCESS:
      return {
        ...state,
        header: {
          ...action.results,
          loading: false,
          responseData: action.responseData,
        },
      };

    case actionTypes.SET_LOAD_HEADER_BUNDLE:
      return {
        ...state,
        ...(state.header && {
          header: {
            ...state.header,
            blocks: state.header.blocks.map((block) => ({
              ...block,
              hide: block.charts.find((chart) =>
                chart.hideOnFilters?.find((hof) =>
                  action.activeMenuFilters.includes(hof)
                )
              ),
              charts: block.charts.map((chart) => ({
                ...chart,
                refreshing: action.visualizationIds.includes(
                  chart.visualizationId
                ),
              })),
            })),
          },
        }),
      };

    case actionTypes.EXECUTE_QUERY_FAIL:
      return {
        ...state,
        ...(state.header && {
          header: {
            ...state.header,
            blocks: state.header.blocks.map((block) => ({
              ...block,
              charts: block.charts.map((chart) => ({
                ...chart,
                error: true,
                refreshing: !action.visualizationId,
              })),
            })),
          },
        }),
      };

    case actionTypes.EXECUTE_QUERY_SUCCESS: {
      if (action.slice !== "layout") return { ...state };
      const { data, meta } = action.results;

      const tData = setDataUniqueRowUuid(data);

      const updateChart = doMerge(
        state.header.blocks,
        action.visualizationId,
        tData,
        action.cacheKey,
        meta
      );

      return {
        ...state,
        header: {
          ...state.header,
          blocks: state.header.blocks.map((block) => ({
            ...block,
            charts: block.charts.map((chart) =>
              chart.visualizationId === action.visualizationId
                ? {
                    ...chart,
                    ...updateChart,
                  }
                : chart
            ),
          })),
        },
      };
    }

    case actionTypes.SHOW_SUBMENU:
      return { ...state, showSubmenu: true };

    case actionTypes.HIDE_SUBMENU:
      return { ...state, showSubmenu: false };

    case actionTypes.SELECT_ALL_COMPARISON_FILTERS: {
      return {
        ...state,
        menuFilters: state.menuFilters.map((filter) => {
          if (filter.name === action.key) {
            return {
              ...filter,
              values: filter.values.map((item) => ({
                ...item,
                checked: item.value && action.checked,
              })),
            };
          }

          return filter;
        }),
        comparisonMode: state.comparisonMode.map((item) => {
          if (item.pages.includes(state.activeTab.uuid)) {
            return {
              ...item,
              checked: Number.isFinite(item.count) ? item.count : action.count,
            };
          }
          return item;
        }),
      };
    }

    case actionTypes.SELECT_ALL_GENERAL_FILTERS:
      return produce(state, (draft) => {
        draft.menuFilters.forEach((filter) => {
          if (filter.name === action.name) {
            filter.values = (action.filters ?? []).filter(
              (v) => v.operator !== likeOperator
            );
          }
        });
        if (draft.comparisonMode) {
          const filter = action.filters.find((f) => f.key === action.name);
          applyComparisonSettingsToDraft(draft, filter);
        }
      });

    case actionTypes.SELECT_MULTIPLE_GENERAL_FILTERS:
      return produce(state, (draft) => {
        draft.menuFilters.forEach((filter) => {
          const item = action.menuFilterSettings?.find(
            (setting) => setting.menuFilter.uuid === filter.uuid
          );

          filter.values = filter.values.map((v) => ({
            ...v,
            checked: item?.values?.includes(v.value),
          }));
        });
      });

    case actionTypes.SELECT_FILTER:
      const { key, value, checked, menuFilterUuid, operator } = action.filter;
      const { singleQueryFiltersUuid, filterType, alias } = action;
      let exitOnFound = false;

      return produce(state, (draft) => {
        for (const [menuFilterIndex, menuFilter] of Object.entries(
          state.menuFilters
        )) {
          if (menuFilter.uuid !== menuFilterUuid) {
            continue;
          }

          // drop previous value with like operator
          draft.menuFilters[menuFilterIndex].values = draft.menuFilters[
            menuFilterIndex
          ].values.filter((v) => v.operator !== likeOperator);

          if (operator === likeOperator && value) {
            draft.menuFilters[menuFilterIndex].values.push(action.filter);
          }

          for (const [valueIndex, filter] of Object.entries(
            menuFilter.values
          )) {
            exitOnFound = value === filter.value;
            if (exitOnFound) {
              draft.menuFilters[menuFilterIndex].values[valueIndex].checked =
                checked;
              break;
            }
          }

          if (exitOnFound) {
            break;
          }
        }
        if (singleQueryFiltersUuid) {
          const selectedValues = ensureFieldForSingleQueryFiltersDraft(
            draft,
            singleQueryFiltersUuid,
            key,
            filterType,
            alias
          ).selectedValues;
          const amongValues = selectedValues.includes(value);
          if (checked && !amongValues) {
            selectedValues.push(value);
            selectedValues.sort();
          } else if (!checked && amongValues) {
            pull(selectedValues, value);
          }
        }
        if (draft.comparisonMode) {
          applyComparisonSettingsToDraft(draft, action.filter);
        }
      });

    case actionTypes.CHANGE_COMPARISON_TYPE:
      return produce(state, (draft) => {
        const { options } = action.comparisonModeItem ?? {};

        draft.menuFilters = draft.menuFilters.map((mf) => {
          return {
            ...mf,
            values: options?.includes(mf.name)
              ? mf.values.map((v) => ({ ...v, checked: false }))
              : mf.values,
          };
        });
        draft.comparisonMode = draft.comparisonMode?.map((item) => {
          if (item.pages.includes(draft.activeTab.uuid)) {
            return { ...item, checked: 0 };
          }
          return item;
        });
      });

    case actionTypes.CHANGE_COMPARISON_MODE_FILTER_NAME:
      return { ...state, comparisonModeFilterName: action.name };

    case actionTypes.SELECT_MULTI_RANGE_FILTER: {
      return produce(state, (draft) => {
        const { filter } = action;
        const { singleQueryFiltersUuid, filterType, alias } = filter;
        if (singleQueryFiltersUuid) {
          const fieldDraft = ensureFieldForSingleQueryFiltersDraft(
            draft,
            singleQueryFiltersUuid,
            filter.name,
            filterType,
            alias
          );
          const values = [filter.min, filter.max];
          if (!isEqual(values, fieldDraft.selectedValues)) {
            fieldDraft.selectedValues = !filter.isFullRange ? values : [];
          }
          return;
        }
        for (const item of draft.menuFilters) {
          if (item.uuid === action.filter.uuid) {
            const checked = !action.filter.isFullRange;
            item.values = [
              {
                type: action.filter.type,
                key: action.filter.type,
                value: action.filter.min,
                label: formatter(action.filter.min, ".3s"),
                checked,
              },
              {
                type: action.filter.type,
                key: action.filter.type,
                value: action.filter.max,
                label: formatter(action.filter.max, ".3s"),
                checked,
              },
            ];
          }
        }
      });
    }

    case actionTypes.SELECT_SLIDER:
      const filterIndex = state.menuFilters.findIndex(
        (f) => f.name === action.filter.name
      );

      return produce(state, (draft) => {
        if (draft.menuFilters[filterIndex]) {
          draft.menuFilters[filterIndex].selectedValue =
            action.filter.selectedValue;
        }
      });

    case actionTypes.SELECT_DATE_RANGE_FILTER:
      return produce(state, (draft) => {
        for (const item of draft.menuFilters) {
          if (item.name === action.name) {
            item.values = action.filters;
          }
        }
      });

    case actionTypes.SELECT_SINGLE_DATE_FILTER:
      return produce(state, (draft) => {
        for (const item of draft.menuFilters) {
          if (item.name === action.name) {
            item.values = [
              {
                ...action.filters[0],
                checked: item.values[0]?.value !== action.filters[0]?.value,
              },
            ];
          }
        }
      });

    case actionTypes.SELECT_DATE_PRESETS_FILTER:
      return produce(state, (draft) => {
        const { singleQueryFiltersUuid, name, filters, filterType, alias } =
          action;
        if (singleQueryFiltersUuid) {
          const fieldDraft = ensureFieldForSingleQueryFiltersDraft(
            draft,
            singleQueryFiltersUuid,
            name,
            filterType,
            alias
          );
          const values = filters.filter((f) => f.checked).map((f) => f.value);
          if (!isEqual(values, fieldDraft.selectedValues)) {
            fieldDraft.selectedValues = values;
          }
          return;
        }

        for (const item of draft.menuFilters) {
          if (item.name === action.name) {
            item.values = action.filters;
          }
        }
      });

    case actionTypes.SAVE_SELECTED_DATE_PESETS_FILTER_MAP:
      return {
        ...state,
        customDatesFilterTypeMap: {
          ...state.customDatesFilterTypeMap,
          ...action.customDateKeyValue,
        },
      };

    // Unselect everything else when selecting an item.
    case actionTypes.SELECT_SINGLE_FILTER:
      return produce(state, (draft) => {
        for (const item of draft.menuFilters) {
          for (const el of item.values) {
            if (el.menuFilterUuid !== action.filter.menuFilterUuid) {
              break;
            }
            el.checked = el.checked ? false : action.filter.value === el.value;
          }
        }
      });

    case actionTypes.SET_BOOLEAN_FILTER:
      return {
        ...state,
        booleanFilters: state.booleanFilters.map((b) =>
          b.key === action.key
            ? { ...b, checked: action.checked, value: action.value }
            : b
        ),
      };

    case actionTypes.RESET_FILTERS:
      return {
        ...state,
        multiRangeFilters: null,
        menuFilters: state.menuFilters.map((filter) => ({
          ...filter,
          values: filter.values.map((value) => ({
            ...value,
            checked: isChecked(
              { ...filter, values: filter.values.map((x) => x.value) },
              value.value
            ),
          })),
        })),
        singleQueryFiltersByQueryUuid: {},
        booleanFilters:
          state.booleanFilters &&
          state.booleanFilters.map((filter) => ({
            ...filter,
            checked: false,
          })),
      };

    // Turn off everything, then set new filters, also for insights
    case actionTypes.SET_FILTER:
      function matchFilterValue(value) {
        const match = action.filters.find((fil) => {
          return fil.key === value.key && value.value === fil.value;
        });
        return !!match;
      }

      return {
        ...state,
        menuFilters: state.menuFilters.map((filter) => ({
          ...filter,
          values: filter.values.map((value) => ({
            ...value,
            checked: matchFilterValue(value),
          })),
        })),
        booleanFilters:
          state.booleanFilters &&
          state.booleanFilters.map((filter) => ({
            ...filter,
            checked: false,
          })),
      };

    case CACHE_MENU_FILTER_CHECKED_VALUES: {
      return produce(state, (draft) => {
        draft.menuFiltersSelectedValuesByMenuFilterUuid[
          action.payload.menuFilterUuid
        ] = action.payload.values;
      });
    }

    case actionTypes.LOAD_MENU_FILTER_VALUES_START: {
      return {
        ...state,
        menuFilterValueShortlists: {
          ...state.menuFilterValueShortlists,
          [action.payload.menuFilterUuid]: "loading",
        },
      };
    }

    case actionTypes.LOAD_MENU_FILTER_VALUES_SUCCESS: {
      const data = action.results.data;

      return {
        ...state,
        menuFilterValueShortlists: {
          ...state.menuFilterValueShortlists,
          [action.payload.menuFilterUuid]: data.values,
        },
      };
    }

    case actionTypes.RESET_MENU_FILTER_VALUES: {
      return produce(state, (draft) => {
        delete draft.menuFilterValueShortlists[action.payload];
      });
    }

    case actionTypes.SET_DATE_FILTERS: {
      return {
        ...state,
        dateFilters: action.dateFilters,
        dateFilterType: action.dateType?.value,
      };
    }

    case actionTypes.SET_CURRENT_DATE_FILTER_TERM:
      const term = action.term?.value ?? action.term;
      return {
        ...state,
        currentDateTerm: getCurrentDateTerm(term),
        currentDateTermCode: term,
      };

    case CHANGE_THEME_CONFIGURATION_SUCCESS: {
      return {
        ...state,
        theme: {
          ...state.theme,
          name: action.config,
        },
        userSelectedThemeName: action.config,
      };
    }

    case SET_USER_SELECTED_THEME_NAME: {
      return {
        ...state,
        userSelectedThemeName: action.payload ?? null,
      };
    }

    case actionTypes.HIDE_HEADER: {
      return produce(state, (draft) => {
        draft.headerVis = false;
        draft.header.headerVis = false;
      });
    }

    case actionTypes.SET_DATE_TERM: {
      return produce(state, (draft) => {
        draft.term = action.term;
      });
    }

    case actionTypes.GET_ISSUE_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        importantNotifications: action.data,
      };

    case actionTypes.SAVE_DATA_LOAD_ISSUE_NOTIFICATION_START:
      return {
        ...state,
        importantNotificationsLoading: true,
      };

    case actionTypes.SAVE_DATA_LOAD_ISSUE_NOTIFICATION_SUCCESS:
    case actionTypes.SAVE_DATA_LOAD_ISSUE_NOTIFICATION_FAIL:
      return {
        ...state,
        importantNotificationsLoading: false,
      };

    case actionTypes.GET_PAGES_SUCCESS:
      return {
        ...state,
        tabs: action.results,
        tabsError: null,
      };

    case actionTypes.GET_PAGES_FAIL:
      return {
        ...state,
        tabsError: action.payload,
      };

    case actionTypes.EXTEND_MENU_FILTERS:
      if (action.filters.length === 0) {
        return {
          ...state,
          menuFilters: state.menuFilters.filter((mf) => !mf.extended),
        };
      }

      const map = new Map();

      state.menuFilters
        .filter((mf) => !mf.extended)
        .forEach((mf) => map.set(mf.name, mf));
      action.filters.forEach((f) => map.set(f.name, f));

      return {
        ...state,
        menuFilters: [...map.values()],
      };

    case actionTypes.SET_FULL_PAGE_STICKY_HEADERS:
      return {
        ...state,
        isGlobalSticky: action.isSticky,
      };

    case actionTypes.GET_MENU_FILTER_VALUES_START:
      return {
        ...state,
        searchFilterLoading: true,
      };

    case actionTypes.GET_MENU_FILTER_VALUES_SUCCESS:
      const { results, filter } = action;

      function createFilterItem(value) {
        const { name } = filter;
        return {
          key: name,
          type: name,
          value,
          label: value,
          checked: false,
          menuFilterUuid: filter.uuid,
        };
      }

      const values = results.data.map(createFilterItem);

      function removeDuplicates(val, checked) {
        return !checked.find((check) => check.value === val.value);
      }

      function updateFilterValues(item) {
        const { uuid } = filter;
        const checked = item.values.filter((value) => value.checked);

        if (item.uuid === uuid) {
          return {
            ...item,
            values: [
              ...checked,
              ...values.filter((val) => removeDuplicates(val, checked)),
            ],
          };
        }

        return item;
      }

      return {
        ...state,
        menuFilters: state.menuFilters.map(updateFilterValues),
        searchFilterLoading: false,
      };

    case actionTypes.GET_MENU_FILTER_VALUES_FAIL:
      return {
        ...state,
        searchFilterLoading: false,
      };

    case actionTypes.SAVE_STICKY_DATE_TYPE:
      const { pageUuid, term: dateTerm, dateOption } = action;
      const config = state.dateFiltersConfig ?? {};

      return {
        ...state,
        dateFiltersConfig: {
          ...config,
          pageOriented: (config.pageOriented ?? []).map((item) =>
            setUserSelectedDates(item, pageUuid, dateTerm, dateOption)
          ),
          // for non grouped pages also remember user selection
          savedDates: {
            ...(config.savedDates ?? {}),
            [pageUuid]: {
              userSelected: dateTerm, // first select
              dateOption, // second Select
            },
          },
          whenStickyDateWasSet: new Date(),
        },
      };

    case actionTypes.GET_SAVED_MENU_FILTER_GROUPS_START: {
      return {
        ...state,
        menuFilterGroupsLoading: true,
      };
    }

    case actionTypes.GET_SAVED_MENU_FILTER_GROUPS_SUCCESS: {
      return {
        ...state,
        savedMenuFilterGroups: action.results.data,
        menuFilterGroupsLoading: false,
      };
    }

    case actionTypes.GET_SAVED_MENU_FILTER_GROUPS_FAIL: {
      return {
        ...state,
        menuFilterGroupsLoading: false,
      };
    }

    case actionTypes.GET_SAVED_MENU_FILTER_GROUP_START:
      return {
        ...state,
        menuFilterGroupUuid: action.isOverride ? null : action.uuid,
        menuFilterGroupOverride: action.isOverride,
      };

    case actionTypes.GET_SAVED_MENU_FILTER_GROUP_SUCCESS:
    case actionTypes.GET_SAVED_MENU_FILTER_GROUP_FAIL:
      return {
        ...state,
        menuFilterGroupUuid: null,
        menuFilterGroupOverride: false,
      };

    case actionTypes.SAVE_FILTERS_FOR_NEW_PAGE: {
      const selectedFilters = state.menuFilters.flatMap((mf) =>
        mf.values.filter((v) => v.checked)
      );
      localStorage.setItem("selectedFilters", JSON.stringify(selectedFilters));
      return state;
    }

    case actionTypes.RESET_CURRENT_DATE_STRING: {
      return {
        ...state,
        currentDateString: formatISODate(new Date()),
      };
    }

    default:
      return state;
  }
}

export function filterMapMenuFilters(
  tenantConfig,
  additionalTheme,
  localMenuFilterSettings
) {
  return tenantConfig.menuFilters
    .filter((filter) =>
      removeHiddenFilters(filter, additionalTheme.hiddenFilters)
    )
    .map(setSpecialCcgDefaultFilterValue)
    .map(limitDateRangeFilterType)
    .map((item) => mapMenuFilters(item, localMenuFilterSettings))
    .map((item) => clearDatePresetsFilters(item, tenantConfig.domain))
    .map(overrideByLocalStorage);
}

// set user selected dates to pages in gorup
function setUserSelectedDates(item, pageUuid, dateTerm, dateOption) {
  const ids = item.pageUuids ?? [item.pageUuid];
  if (ids.includes(pageUuid)) {
    return {
      ...item,
      userSelected: dateTerm.value,
      dateOption,
    };
  }

  return item;
}

function getCurrentDateTerm(term) {
  const { label } = customFilterOptions.find(
    (option) => option.value === term
  ) ?? { label: "Selected Range" };

  return `[${label}]`;
}

function buildDateRangeFilterValues(item) {
  if (item.type !== FILTER_TYPE_DATE_RANGE) {
    return null;
  }

  function getStartDate() {
    const presetType = (item.defaultValues ?? [])[0];
    if (presetType) {
      // set correct custom default start date
      return format(
        formatISODate(convertCustomDefaultValue(presetType)),
        "yyyy-MM-dd"
      );
    }
    // set start of month by default if not exist
    return format(startOfMonth(endOfYesterday()), "yyyy-MM-dd");
  }

  const start = getStartDate();
  const end = format(endOfYesterday(), "yyyy-MM-dd");

  // do not remove these lines
  // const { defaultValues } = item;
  // return defaultValues?.length ? defaultValues : ["Start", "End"];
  return [start, end];
}

function mapBasicMenuFilters(item) {
  return {
    ...item,
    displayName: item.displayName ?? item.name,
    type: item.type || filterTypes[0].value,
  };
}

function limitDateRangeFilterType(item) {
  if (item.type === FILTER_TYPE_DATE_RANGE) {
    return {
      ...item,
      values: [item.values[0], item.values[item.values.length - 1]],
      ...(item.labeledValues && {
        labeledValues: [
          item.labeledValues[0],
          item.labeledValues[item.labeledValues.length - 1],
        ],
      }),
    };
  }

  if (item.type === FILTER_TYPE_SINGLE_DATE) {
    return {
      ...item,
      values: [],
    };
  }

  return item;
}

function overrideByLocalStorage(filter) {
  const selectedFilters = localStorage.getItem("selectedFilters");

  if (!selectedFilters) {
    return filter;
  }

  const parsedFilters = JSON.parse(selectedFilters);

  return {
    ...filter,
    values: filter.values.map((v) => ({
      ...v,
      checked: parsedFilters.some(
        (item) => item.menuFilterUuid === filter.uuid && v.value === item.value
      ),
    })),
  };
}

function clearDatePresetsFilters(item, domain) {
  if (item.type !== FILTER_TYPE_DATE_PRESETS) {
    return item;
  }

  // if we have default value in date presets then apply them like default menu filter
  const defaultValue = (item.defaultValues ?? [])[0];
  if (defaultValue) {
    const { from, to } = setDateFilters(domain, defaultValue);
    const values = buildFilters(from, to, item.name);
    return { ...item, values };
  }

  return { ...item, values: [] };
}

function setSpecialCcgDefaultFilterValue(filter) {
  const key = "MonthYear";

  if (filter.name !== key) {
    return filter;
  }

  // only one item there but in future can be more
  const { defaultSelected } =
    customFilterTypes.find((custom) => custom.type === key) ?? {};

  return {
    ...filter,
    ...(defaultSelected && { defaultValues: defaultSelected }),
  };
}

// this function replace original values with gaps to ordered multi range slider with step 1
function createArrayWithStep(min, max) {
  const resultArray = [min, max];
  // We shouldn't need this anymore
  // const steps = 100;
  // const stepSize = (max - min) / steps;
  //
  // for (let i = 0; i <= steps; i++) {
  //   resultArray.push(min + i * stepSize);
  // }

  return resultArray;
}

export function mapMenuFilters(item, localMenuFilterSettings) {
  const isBooleanType = item.dataSourceFieldType === "boolean";
  const values = buildDateRangeFilterValues(item) || [...item.values];
  const valuesToUse = isBooleanType ? [true, false, null] : values;

  const labeledValues = item.labeledValues
    ? [...item.labeledValues]
    : valuesToUse.map((value) => ({
        value,
        label: value,
      }));

  const retVal = {
    ...mapBasicMenuFilters(item),
    showEmptyValues: isBooleanType ? true : undefined,
    values: labeledValues
      .sort((a, b) => {
        return isMultiRangeFilterType(item.type)
          ? castToNumber(a.label) - castToNumber(b.label)
          : 0;
      })
      .map(mapMenuFilterValue(item, localMenuFilterSettings)),
  };

  if (item.type === "slider" && item.defaultValues?.length) {
    retVal.selectedValue = item.defaultValues[0];
  }

  if (isMultiRangeFilterType(item.type)) {
    const min = +retVal.values[0]?.value;
    const max = +retVal.values[retVal.values.length - 1]?.value;
    retVal.limitMin = min;
    retVal.limitMax = max;

    const defaults = (item.defaultValues ?? []).map(Number);
    const array = [...createArrayWithStep(min, max), ...defaults];

    retVal.values = [...new Set(orderBy(array))].map((value) => ({
      key: item.name,
      type: item.name,
      checked: defaults.includes(value),
      value,
      label: formatter(value, ".3s"),
    }));
  }

  return retVal;
}

function getHardCodedLabel(name, value, values) {
  const hardCoded = hardCodedFilterLabels[name];
  if (hardCoded) {
    return hardCoded[value];
  }

  // more then 2 values mean that its not boolean like filter
  if ((values ?? []).length > 2) {
    return value;
  }

  const no = value === "0" || value === 0 || value === false;
  const yes = value === "1" || value === 1 || value === true;

  return no ? "No" : yes ? "Yes" : value;
}

function isJsonString(value) {
  // do not parse numbers or stringed numbers
  // something strange happen in js when you do JSON.parse("401916510162963932") or +"401916510162963932"
  // js cast this to different value like that 401916510162963900
  if (!isNaN(+value)) {
    return value;
  }

  try {
    JSON.parse(value);
  } catch (e) {
    return value;
  }
  return JSON.parse(value);
}

// correct priority for checked filters
// user saved filters is top priority if they exists
function getCorrectIsCheckedByPriority(filter, value, userSavedFilters) {
  const saved = userSavedFilters ?? {};
  const defaults = filter.defaultValues ?? [];

  const currentFilter = {
    ...filter,
    defaultValues: defaults.map((value, index) =>
      index === 0 ? convertCustomDefaultValue(value) : value
    ),
  };

  if (saved[currentFilter.uuid]?.length) {
    return isInSavedMenuFilterSettings(userSavedFilters, currentFilter, value);
  }

  return (
    isChecked(currentFilter, value) || isInLocalStorage(currentFilter, value)
  );
}

function mapMenuFilterValue(item, localMenuFilterSettings) {
  return (labeledValue) => {
    let { label, value } = labeledValue;
    value = typeof value === "boolean" ? (value ? "1" : "0") : value;
    const convertToYesNo = getHardCodedLabel(item.name, label, item.values);

    return {
      key: item.name,
      type: item.name,
      value: isJsonString(value),
      label: item.type !== "multiRange" ? convertToYesNo : label,
      checked: isMultiRangeFilterType(item.type)
        ? false // For multiRange filters, values are unset by default
        : getCorrectIsCheckedByPriority(item, value, localMenuFilterSettings),
      menuFilterUuid: item.uuid,
    };
  };
}

/**
 * @deprecated Should be removed in the future once most localStorage filters
 *  have gotten saved to the API.
 */
function isInLocalStorage(filter, value) {
  const localStorageValues = getFiltersFromLocalStorage();
  return (localStorageValues[filter.uuid] || []).includes(value);
}

export function mapToStringThenCompare(array, value) {
  return array.some((val) => val + "" === value + "");
}

export function isInSavedMenuFilterSettings(
  localMenuFilterSettings,
  filter,
  value
) {
  if (value !== null && typeof value === "object") {
    return (localMenuFilterSettings[filter.uuid] || []).some(
      isEqual.bind(null, value)
    );
  }

  return mapToStringThenCompare(
    localMenuFilterSettings[filter.uuid] || [],
    value
  );
}

function isChecked(filter, value) {
  // force check date range filter as default
  if (filter.type === FILTER_TYPE_DATE_RANGE || filter.number) {
    return true;
  }

  const val = value && typeof value === "string" ? value.trim() : value;

  const defaults = filter.defaultValues ?? [];
  return defaults.includes(val) || defaults.includes(val + "");
}

/**
 * Converts the dataSourcesAccess property coming from the API to a value that's
 * better to work with.
 */
export function convertDataSourcesAccess(dataSourcesAccess) {
  const ret = {
    dataSources: {
      hasWhitelist: false,
      byUuid: {},
    },
    dataSourceFields: {
      hasWhitelist: false,
      byUuid: {},
    },
    dataSourceFieldValues: {
      hasWhitelist: false,
      byUuid: {},
    },
    paramValue: null,
  };

  for (const dataSourceAccess of dataSourcesAccess) {
    ret.dataSources.hasWhitelist = true;
    ret.dataSources.byUuid[dataSourceAccess.dataSourceUuid] = {
      displayName: dataSourceAccess.displayName,
    };
    for (const fieldAccess of dataSourceAccess.fieldsAccess) {
      ret.dataSourceFields.hasWhitelist = true;
      ret.dataSourceFields.byUuid[fieldAccess.dataSourceFieldUuid] = {};
    }
    for (const allowedValues of dataSourceAccess.allowedValues) {
      ret.dataSourceFieldValues.hasWhitelist = true;
      ret.dataSourceFieldValues.byUuid[allowedValues.dataSourceFieldUuid] = {
        values: allowedValues.values,
      };
      if (!ret.paramValue) ret.paramValue = allowedValues.values[0];
    }
  }

  return ret;
}

function configureStartDate(
  domain,
  config,
  dateFilterMode,
  dateFilterSettings // user seaved settings
) {
  if (
    config.globalMinimumDate &&
    config.filterCustomTerm === DATE_TERM_MONTH_TO_MONTH
  ) {
    return config.globalMinimumDate;
  }

  if (dateFilterMode === DATE_FILTER_MODE_CUSTOM) {
    const term = config.filterCustomTerm ?? config.filterCustomValues[0];

    return setDateFilters(
      domain,
      term,
      config.rangeSettingsRange,
      dateFilterSettings?.startDate,
      dateFilterSettings?.endDate,
      config
    ).from;
  }

  return fromToDateFormatter(
    config.rangeSettingsTerm,
    config.rangeSettingsRange
  ).from;
}

function configureEndDate(config, dateFilterMode, domain, dateFilterSettings) {
  if (
    config.globalMaximumDate &&
    config.filterCustomTerm === DATE_TERM_MONTH_TO_MONTH
  ) {
    return config.globalMaximumDate;
  }

  if (dateFilterMode === DATE_FILTER_MODE_CUSTOM) {
    return setDateFilters(
      domain,
      config.filterCustomTerm,
      undefined,
      dateFilterSettings?.startDate,
      dateFilterSettings?.endDate,
      config
    ).to;
  }

  return fromToDateFormatter(
    config.rangeSettingsTerm,
    config.rangeSettingsRange
  ).to;
}

function setNewBooleans({ booleanFilters, booleans }) {
  if (booleans?.length) {
    return booleans.map((b) => ({
      key: b.column,
      label: b.displayName,
      checked: false,
      value: true,
      hideOnPages: b.hideOnPages,
      onLabelOverride: b.onLabelOverride,
      offLabelOverride: b.offLabelOverride,
    }));
  }

  if (booleanFilters) {
    return booleanFilters.map((b) => {
      const [key, label] = b.split("::");
      return { key, label, checked: false, value: true };
    });
  }

  return [];
}

function removeHiddenFilters(filter, hiddenFilters = {}) {
  return !hiddenFilters[filter.uuid];
}

/**
 * Returns a subdraft representing a query field for single query menu filters.
 * If the field does not yet exist in the state, it gets created first.
 *
 * @param draft
 * @param singleQueryFiltersUuid
 * @param key
 * @param filterType
 * @param alias
 * @returns {*}
 */
function ensureFieldForSingleQueryFiltersDraft(
  draft,
  singleQueryFiltersUuid,
  key,
  filterType,
  alias
) {
  if (!draft.singleQueryFiltersByQueryUuid[singleQueryFiltersUuid]) {
    draft.singleQueryFiltersByQueryUuid[singleQueryFiltersUuid] = {
      fieldsByName: {},
    };
  }
  const fieldsByName =
    draft.singleQueryFiltersByQueryUuid[singleQueryFiltersUuid].fieldsByName;
  if (!fieldsByName[key]) {
    fieldsByName[key] = { key, alias, selectedValues: [] };
  }
  fieldsByName[key].filterType = filterType;
  return fieldsByName[key];
}

function getComparisonModeOptionsByDomain(domain, tenantComparisonMode) {
  switch (domain) {
    case "ccg":
      return comparisonOptions;

    case "demoem":
      return comparisonOptionsDemo;

    case "cspring":
      return comparisonOptionsSpringDemo;

    case "pro-sports":
      return comparisonOptionsProSports;

    default:
      return tenantComparisonMode;
  }
}
